import { cn } from "@/lib/utils"

/** Small circular spinner matching the design's Loader_Circle. */
export function Spinner({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        "inline-block animate-spin rounded-full border-2 border-purple-light border-t-transparent",
        className,
      )}
    />
  )
}
